import React, { useState, useEffect } from 'react';

const ProgressBar = () => {
  const [scroll, setScroll] = useState(0);

  useEffect(() => {
    const updateScroll = () => {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = (window.scrollY / scrollHeight) * 100;
      setScroll(scrolled);
    };

    // Initial calculation
    updateScroll();

    // Add scroll event listener
    window.addEventListener('scroll', updateScroll);
    
    // Cleanup
    return () => window.removeEventListener('scroll', updateScroll);
  }, []);

  return (
    <div 
      className="progress-bar" 
      style={{ '--scroll': `${scroll}%` }}
    />
  );
};

export default ProgressBar; 